import React from "react";
import styled from "styled-components";

const TitleHeader = styled.h1`
  width: 220px;
  height: 24px;
  margin-top: 20px;
  margin-left: 14px;
  font-family: PlayfairDisplay;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 24px;
  color: ${(props) => props.theme.colors.text_color_dark_mode};
`;

const Header2 = styled.h1`
  height: 24px;
  margin-top: 20px;
  font-family: PlayfairDisplay;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 24px;
  color: ${(props) => props.theme.colors.text_color_dark_mode};
  margin-left: 21px;
`;

const Header3 = styled.h1`
  margin-top: 20px;
  margin-left: 14px;
  font-family: PlayfairDisplay;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 24px;
  color: #fffcf2;
`;

export { TitleHeader, Header2, Header3 };
